/**
 * Central location config for the Orosz Coaching physical partnership gym.
 * Referenced from ContactSection, ProgramsSection, BookingModal, etc.
 * Update this single file if the partnership address ever changes.
 */
export const GYM_VENUE = {
  name: 'BB Gym Miskolc',
  street: 'Szeles u. 71.',
  city: 'Miskolc',
  postalCode: '3526',
  country: 'Magyarország',
  // Full-line address for label rendering.
  fullAddress: '3526 Miskolc, Szeles u. 71.',
  // Public Google Maps embed URL — no API key required.
  // Uses the `output=embed` shortcut which serves a fully-interactive map.
  mapEmbedUrl:
    'https://maps.google.com/maps?q=3526%20Miskolc%2C%20Szeles%20u.%2071&t=&z=16&ie=UTF8&iwloc=&output=embed',
  // Deep-link for "Open in Google Maps" CTAs.
  mapDeepLink:
    'https://www.google.com/maps/search/?api=1&query=3526+Miskolc%2C+Szeles+u.+71',
  // Weekly opening hours — matches the Schema.org OpeningHoursSpecification
  // structure baked into the LocalBusiness JSON-LD in /public/index.html.
  // Keep both in sync if hours ever change.
  openingHours: [
    {
      daysHu:    'Hétfő – Péntek',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens:     '05:00',
      closes:    '21:00',
    },
    {
      daysHu:    'Szombat – Vasárnap',
      dayOfWeek: ['Saturday', 'Sunday'],
      opens:     '07:00',
      closes:    '20:00',
    },
  ],
};

/** Shorthand label used inside program cards and booking modals. */
export const GYM_VENUE_LABEL = `${GYM_VENUE.name}, ${GYM_VENUE.street}`;
